import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom';


// Login
import Login from './Routes/Login';
import LoginMock from './Routes/LoginMock';
//Registration
import RegistrationSelect from './Routes/RegistrationSelect'; 
import Registration from './Routes/Registration';
import InsertUserandPassword from './Routes/InsertUserandPassword';
import RegistrationResult from './Routes/RegistrationResult';
//Home
import Home from './Routes/Home';
import Movimenti from './Routes/Movimenti';
import MovimentiMock from './Routes/MovimentiMock';
import Riepilogo from './Routes/Riepilogo';
import StatisticaMensile from './Routes/StatisticaMensile';
import StatisticaTrimestrale from './Routes/StatisticaTrimestrale';
import StatisticaSemestrale from './Routes/StatisticaSemestrale';
import DifferenzeContabili from './Routes/DifferenzeContabili';
import AddebitiAccrediti from './Routes/AddebitiAccrediti';
import Layout from './Layout';

//Estatto conto
import EstrattoConto from './Routes/EstrattoConto';

//Dispute Online
import Dispute from './Routes/Dispute';
import DisputeRegistered from './Routes/DisputeRegistered';

//Insoluti
import Insoluti from './Routes/Insoluti'

//Setting
import Report from './Routes/Report';
//import ReportRicerca from './Routes/ReportRicerca';
/*import PraticheGestore from './Routes/PraticheGestore';
import GestioneRichieste from './Routes/GestioneRichieste';*/
import DettaglioPraticaDispute from './Routes/DettaglioPraticaDispute';
import StatoPratiche from './Routes/StatoPratiche';
import InsertOTP from './Routes/InsertOTP';
import InsertOTPReg from './Routes/InsertOTPReg';
import InsertTelephoneNumber from './Routes/InsertTelephoneNumber';
import ModifyTelephoneNumber from './Routes/ModifyTelephoneNumber';
import InsertEmail from './Routes/InsertEmail';
import ModificaPasswordSteps from './Routes/ModificaPasswordSteps';
import ModificaEmailSteps from './Routes/ModificaEmailSteps';
import Setting from './Routes/Setting';
/*import CertificaEmail from './Routes/CertificaEmail';*/
import InsertPassword from './Routes/InsertPassword';
/*import AggiornaPasswordSteps from './Routes/AggiornaPasswordSteps';*/
import ErrorPage from './Components/ErrorPage';
import ResultPage from './Components/ResultPage';
import InserisciVecchiaPassword from './Components/InserisciVecchiaPassword';
//import GestioneRichiesteStep5 from './Components/GestioneRichiesteStep5';


const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={props =>
    ((sessionStorage.getItem('token') === null)
      ? <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
      : <Component {...props} />
    )} />
);


/* <Route
   {...rest}
   render={props =>
     (sessionStorage.getItem('token') !== null || sessionStorage.getItem('token') !== '' || sessionStorage.getItem('token') !== undefined) ? (
       <Component {...props} />
     ) : (
         <Redirect
           to={{
             pathname: "/login",
             state: { from: props.location }
           }}
         />
       )
   }
 />
);*/




class Menu extends Component {
  static propTypes = {
    match: PropTypes.object,
    location: PropTypes.object,
    history: PropTypes.object
  }
  render() {
    return (
      <Router>
        <Switch>
          <Route exact path='/' component={Login} />
          <Route exact path='/login' component={Login} />
          {process.env.NODE_ENV === 'development' && <Route exact path='/login-mock' component={LoginMock} />}
          {process.env.NODE_ENV === 'development' && <Route exact path='/movimenti-mock' component={MovimentiMock} />}

          <Route exact path='/RegistrationSelect' component={RegistrationSelect} />
          <Route exact path='/ShopRegistration' component={Registration} />
          <Route exact path='/SocietyRegistration' component={Registration} />
          <Route exact path='/ValidateRegistration' component={InsertUserandPassword} />
          <Route exact path='/OTPCodeReg' component={InsertOTPReg} />
          <Route exact path='/ErrorPageReg' component={ErrorPage} />
          <Route exact path='/RegistrationResult' component={RegistrationResult} />
          {/*<Route exact path='/Upload' component={GestioneRichiesteStep5} />*/}


          <PrivateRoute exact path='/InsertTelephone' component={InsertTelephoneNumber} /> {/*inserire route nel private*/}
          <PrivateRoute exact path='/InsertEmail' component={InsertEmail} />
          <PrivateRoute exact path='/InsertPassword' component={InsertPassword} />
          <PrivateRoute exact path='/OTPCode' component={InsertOTP} />
          <PrivateRoute exact path='/ErrorPage' component={ErrorPage} />
          <PrivateRoute exact path='/ResultPage' component={ResultPage} />
          <PrivateRoute exact path='/AggiornaPassword' component={ModificaPasswordSteps} />
          <PrivateRoute exact path='/ChangePassword' component={InserisciVecchiaPassword} />
          <Layout>
            <PrivateRoute exact path='/Home' component={Home} />
            <PrivateRoute exact path='/Home/Movimenti' component={Movimenti} />
            <PrivateRoute exact path='/Home/Riepilogo' component={Riepilogo} />
            <PrivateRoute exact path='/Home/StatisticaMensile' component={StatisticaMensile} />
            <PrivateRoute exact path='/Home/StatisticaTrimestrale' component={StatisticaTrimestrale} />
            <PrivateRoute exact path='/Home/StatisticaSemestrale' component={StatisticaSemestrale} />
            <PrivateRoute exact path='/Home/DettaglioDifferenzeContabili' component={DifferenzeContabili} />
            <PrivateRoute exact path='/Home/AddebitiContestazioni' component={AddebitiAccrediti} />
            <PrivateRoute exact path='/EstrattoConto' component={EstrattoConto} />
            <PrivateRoute exact path='/DisputeOnline' component={Dispute} />
            <PrivateRoute exact path='/DisputeOnlineRegistered' component={DisputeRegistered} />

            <PrivateRoute exact path='/Dispute/Report' component={Report} />
            {/*<PrivateRoute exact path='/Dispute/ReportResult' component={ReportRicerca} />*/}
            {/*<PrivateRoute exact path='/Dispute/PraticheGestore' component={() => <PraticheGestore />} />*/}
            <PrivateRoute exact path='/Dispute/DettaglioPratica' component={DettaglioPraticaDispute} />
            <PrivateRoute exact path='/Dispute/StatoPratiche' component={StatoPratiche} />
            <PrivateRoute exact path='/Insoluti' component={Insoluti} />
            {/*<PrivateRoute exact path='/Dispute/GestioneRichieste' component={() => <GestioneRichieste />} />*/}
            <PrivateRoute exact path='/Setting' component={Setting} />
            <PrivateRoute exact path='/Setting/ModificaTelefono' component={ModifyTelephoneNumber} />
            <PrivateRoute exact path='/Setting/ModificaPassword' component={ModificaPasswordSteps} />
            <PrivateRoute exact path='/Setting/ModificaEmail' component={ModificaEmailSteps} />

          </Layout>
        </Switch>
      </Router>
    )
  }
}


export default Menu;
